import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../../material.module';
import { ShapeFormComponent } from './shape-form.component';

@NgModule({
  declarations: [ShapeFormComponent],
  imports: [CommonModule, FormsModule, MaterialModule],
  exports: [ShapeFormComponent],
})
export class ShapeFormModule {}

